const ssIcon = document.createElement('link');
ssIcon.rel = 'stylesheet';
ssIcon.href = '/wp-content/themes/shibuya-lrc/fonts/ss-gizmo.css';
ssIcon.onload = function () {
  document.body.classList.add('loaded-gizmo-icons');
};

const ssSocial = document.createElement('link');
ssSocial.rel = 'stylesheet';
ssSocial.href = '/wp-content/themes/shibuya-lrc/fonts/ss-pika.css';
ssSocial.onload = function () {
  document.body.classList.add('loaded-pika-icons');
};

document.body.appendChild(ssIcon);
document.body.appendChild(ssSocial);
